import service_quest_link from './service_quest_link.vue'
const ServiceQuestLink = {
    install: function (Vue) {
        Vue.component('ServiceQuestLink', service_quest_link)
    }
}
export default ServiceQuestLink
